function truncateText(str, length) {
  if (!str) {
    return null;
  }
  if (length !== null && str.length > length) {
    return "".concat(str.substring(0, length), "\u2026");
  } else {
    return str;
  }
}
export default truncateText;